<template>
  <!-- 用户评论的具体内容部分 -->
  <div class="comment_item">
    <!-- 评论用户的头像部分 -->
    <div class="comment_head">
      <div class="comment_head_box">
        <img :src="oneComment.avatar" alt="" />
      </div>
    </div>
    <!-- 用户评论的内容部分 -->
    <div class="comment_content">
      <div>
        <!-- 针对后台回复的情况用户名称为空这里做一次判断，如果用户名为空字符串则使用自定义的名称 -->
        <span class="user_name blur">
          {{oneComment.username == "" ? "班主任" : oneComment.username}}</span
        >
        <span> : </span>
        <span class="comment_content">
          {{ oneComment.content }}
        </span>
      </div>
      <div>
        <!-- 评论的时间以及回复点赞信息 -->
        <commentInfo
          :info="oneComment"
          :share_id="share_id"
          @twoaddcomment="addcommemt($event)"
          :num="num"
        ></commentInfo>
      </div>
      <!-- 剩余评论展开部分 -->
      <div
        class="total_comment"
        v-if="oneComment.children != null && unFlod"
        @click="ChangeUnflod"
      >
        <span class="blur">{{ moreName }}</span>
        <span class="comment_content">等人</span>
        <span class="blur">共{{ oneComment.children.length }}条回复</span>
      </div>
      <div v-if="!unFlod">
        <commentUnflod
          v-for="(item,index) in oneComment.children"
          :key="item.reamrk_id"
          :commentChild="item"
          :share_id="share_id"
          @Addcomment="addcomment($event)"
          :num="index + 1"
        ></commentUnflod>
        <div class="more_comment total_comment">
          <!-- <span class="blur gengduo" @click="moreMethods"
            >更多{{ oneComment.children.length }}条回复</span
          > -->
          <span class="blur gengduo" @click="moreMethods">全部回复</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import commentInfo from "./commentInfo.vue";
import commentUnflod from "./comment_unfold.vue";
export default {
  name: "commentItem",
  components: {
    commentInfo,
    commentUnflod,
  },
  props: {
    num:{
      type: Number,
      default: null,
    },
    role: {
      type: String,
      default: "parent",
    },
    // 传入的一级评论为对象
    oneComment: {
      type: Object,
      default: () => {
        return {
          0: {
            avatar: "http://upload.5kjs.hk/upload/user/626061173.png",
            children: [
              {
                content: "551131是否",
                from_user_name: "测试",
                is_praised: 0,
                level: 3,
                praised_count: 0,
                reamrk_id: 11,
                to_user_name: 15201033560,
              },
            ],
            content: "afafa 一级评论",
            is_praised: 8,
            praised_count: 8,
            reamrk_id: 1,
            username: "测试",
          },
        };
      },
    },
    share_id: {
      type: Number,
      default: 2,
    },
  },
  data() {
    return {
      // 是否展开评论
      unFlod: true,
      // 一级评论的时间以及点赞回复信息
      oneInfo: {},
    };
  },
  computed: {
    // 由于不能直接深层访问子回复中的用户名。所以用遍历获取用户名
    moreName() {
      let a = "";
      this.oneComment.children.forEach((element) => {
        a = element.from_user_name;
        return;
      });
      return a;
    },
  },
  methods: {
    ...mapMutations(["newOpen"]),
    addcomment(event) {
      if (this.oneComment.children != null) {
        this.oneComment.children.unshift(event);
      } else {
        this.oneComment.children = [];
        this.oneComment.children.unshift(event);
        this.$forceUpdate();
        // this.unFlod = false
      }
    },
    ChangeUnflod() {
      this.unFlod = !this.unFlod;
    },
    // 根据组件层级判断是页面跳转还是展开更多数据
    moreMethods() {
      if (this.role == "child") {
        this.list = this.list + 5;
        return;
      }
      this.newOpen(this.share_id);
    },
    // 实时添加新增评论
    addcommemt(event) {
      this.unFlod = false;
      if (this.oneComment.children != null) {
        this.oneComment.children.unshift(event);
      } else {
        this.oneComment.children = [];
        this.oneComment.children.unshift(event);
      }
    },
  },
  mounted() {
    // username 用户名称 praised_count点赞量   reamrk_id 评论ID is_praised是否点赞
    let { username, praised_count, reamrk_id, is_praised } = this.oneComment;
    this.oneInfo = {
      username,
      praised_count,
      reamrk_id,
      is_praised,
      time: "1999.99.99（缺少时间）",
    };
  },
  watch: {
    oneComment(val) {
      if (
        this.role == "parent" &&
        val.children != null &&
        val.children.length < 5
      ) {
        val.children = val.children.slice(0, 4);
      }
    },
  },
};
</script>

<style lang="less" scoped>
// 用户评论的具体内容部分
.comment_item {
  padding: 1.125rem 2.5rem 1.5rem;
  display: flex;
  flex-direction: row;
  background: #ffffff;
  border-bottom: 0.0625rem solid #eeeeee;
  // 用户评论栏的头像部分
  .comment_head {
    width: 1.875rem;
    height: 100%;
    .comment_head_box {
      width: 1.875rem;
      height: 1.875rem;
      border-radius: 50%;
      overflow: hidden;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }

  // 评论内容部分
  .comment_content {
    // width: 35.625rem;
    width: 100%;
    margin-left: 0.5625rem;
    font-size: 0.75rem;
    font-family: "Microsoft YaHei";
    font-weight: 400;
    .comment_content {
      color: #585a58;
    }
    .total_comment {
      padding-left: 0.75rem;
      height: 2.0625rem;
      background: #f6f6f6;
      line-height: 2.0625rem;
      cursor: pointer;
      .comment_content {
        margin-right: 0.5625rem;
      }
    }
    .more_comment {
      height: 2.125rem;
      line-height: 2.125rem;
      cursor: pointer;
    }
    .gengduo:hover {
      border-bottom: 0.0625rem solid #2881b0;
    }
  }

  .comment_info_child {
    /deep/ .comment_info {
      margin: 0.4rem 0;
    }
  }
}
</style>